import styled from 'styled-components';
import { fontSize, fontWeight, mediaMax, primaryColor, tertiaryColor, warningColor } from '@styles/utils';
import CustomLink from '@shared/components/link/CustomLink';
import { Button } from '@styles/shared/buttons';
import FormField from '@shared/modules/form/components/FormField';
import { Checkbox } from '@styles/shared/form/Checkbox';

export const FormContainer = styled.div`
  padding-top: 175px;
  margin-left: 280px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 540px;
  width: 100%;

  @media screen and (${mediaMax.extraLarge}) {
    padding: 92px;
    margin: 0 auto;
  }

  @media screen and (${mediaMax.tablet}) {
    padding: 95px 20px 20px 20px;
    max-width: 100%;
  }
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 36px;
  width: 100%;

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const FormText = styled.p`
  padding-bottom: 20px;
  ${fontSize.standard};
  line-height: 1.61;
`;

export const FormRequired = styled.p`
  padding-bottom: 8px;
  ${fontSize.small};
  color: ${tertiaryColor(400)};
`;

export const FormDoubleInput = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;

  @media screen and (${mediaMax.tablet}) {
    grid-template-columns: 1fr;
  }
`;

export const FormInput = styled(FormField)`
  padding-bottom: 16px;
`;

export const FormPasswordError = styled.p`
  padding-top: 5px;
  ${fontSize.small};
  color: ${warningColor};
`;

export const FormActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FormButton = styled(Button)`
  margin: 32px 0 !important;
  width: max-content;
`;

export const FormCancel = styled(CustomLink)`
  margin-left: 30px;
`;

export const FormDivider = styled.div`
  margin-bottom: 36px;
  opacity: 0.2;
  background-color: #707070;
  max-width: 540px;
  width: 100%;
  height: 1px;

  @media screen and (${mediaMax.tablet}) {
    max-width: 100%;
  }
`;

export const FormWithoutAccount = styled.p`
  padding-bottom: 15px;
  max-width: 540px;
  width: 100%;

  @media screen and (${mediaMax.tablet}) {
    max-width: 100%;
  }
`;

export const FormLinkContainer = styled.div`
  padding-top: 5px;
  text-align: right;
`;

export const FormLink = styled(CustomLink)`
  font-weight: ${fontWeight.standard};
`;

export const FormRetailerContainer = styled.div`
  padding: 8px 10px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgba(232, 245, 238, 0.65);
`;

export const FormRetailerCheckbox = styled(Checkbox)`
  border-color: ${primaryColor(200)};
`;

export const FormRetailerLabel = styled.label`
  padding-left: 8px;
  ${fontSize.standard};
  font-weight: ${fontWeight.normal};
  cursor: pointer;
`;

export const FormCheckboxAccept = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FormAcceptLabel = styled.label`
  padding-left: 8px;
  ${fontSize.label};
  font-weight: ${fontWeight.normal};
  cursor: pointer;
`;

export const FormAcceptError = styled.p`
  color: ${warningColor};
`;
